module.exports = __webpack_public_path__ + "5.0.2/img/r_3_3.0ae7d4e8.png";